import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  FormControlLabel,
  Checkbox,
  IconButton,
  Box,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { BsFillPersonFill, BsBagCheckFill } from "react-icons/bs";
import CommanSpinner from "../components/CommanSpinner";

const AttachOrderDialog = ({
  attachOrder,
  attachOrderPopup,
  closePopup,
  selectedPatientValue,
  selectedOrderValue,
  currentPage,
  moveFaxToTrash,
  setMoveFaxToTrash,
  moveChildFaxToTrash,
  setMoveChildFaxToTrash,
  isLastChild,
  createOrderAndAttach,
  loader,
}) => {
  return (
    <>
      <Button variant="contained" onClick={(e) => attachOrder(e)}>
        ATTACH TO ORDER
      </Button>

      <Dialog
        open={attachOrderPopup}
        onClose={closePopup}
        maxWidth="sm"
        fullWidth
      >
        <Box sx={{ position: "relative" }}>
          <IconButton
            onClick={closePopup}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>

          <DialogTitle sx={{ textAlign: "left", pt: 4 }}>
            Attach to Order
          </DialogTitle>

          <DialogContent>
            If you continue, you will attach the document to the patient and the
            existing order.
            <Box sx={{ mt: 2 }}>
              <Typography
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  mb: 2,
                }}
              >
                <BsFillPersonFill />
                Patient Name: {selectedPatientValue?.name || ""}
              </Typography>

              <Typography
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <BsBagCheckFill />
                Order ID: {selectedOrderValue?.data?.displayId}
              </Typography>
            </Box>
            <Box sx={{ mt: 3 }}>
              {currentPage === "parent" ? (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={moveFaxToTrash}
                      onChange={() => setMoveFaxToTrash(!moveFaxToTrash)}
                      sx={{ "&.Mui-checked": { color: "#00AB4E" } }}
                    />
                  }
                  label="Remove fax from inbox"
                />
              ) : (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={moveChildFaxToTrash}
                      onChange={() =>
                        setMoveChildFaxToTrash(!moveChildFaxToTrash)
                      }
                      sx={{ "&.Mui-checked": { color: "#00AB4E" } }}
                    />
                  }
                  label={
                    isLastChild
                      ? "Move parent fax to trash as well"
                      : "Move child fax to trash"
                  }
                />
              )}
            </Box>
          </DialogContent>

          <DialogActions sx={{ p: 3, justifyContent: "flex-end" }}>
            <Button
              variant="outlined"
              onClick={closePopup}
              sx={{
                color: "#00AB4E",
                borderColor: "#00AB4E",
                "&:hover": {
                  borderColor: "#008C40",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={() => createOrderAndAttach("attach")}
              sx={{
                backgroundColor: "#00AB4E",
                "&:hover": {
                  backgroundColor: "#008C40",
                },
              }}
            >
              Attach
            </Button>
          </DialogActions>
        </Box>

        {/* {loader === "create&attachOrderLoader" && (
          <CommanSpinner spinner={loader} text="" />
        )} */}
      </Dialog>
    </>
  );
};

export default AttachOrderDialog;
